import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PanelCollapse } from '@bepure/tarkin';

const renderPanel = (id: string, panel: { question: string, answer: string }) => {
    const component = (
        <PanelCollapse title={panel.question} isCategoryPanel={false}>
            <div dangerouslySetInnerHTML={{ __html: panel.answer || '' }} />
        </PanelCollapse>
    );
    const element = document.getElementById(id);
    if (element) {
        ReactDOM.render(component, element);
    }
};

export default renderPanel;
